import React from 'react';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import { Dialog, DialogTitle, DialogContent, CardMedia, Stack, Typography, Box } from '@mui/material';
import { useTranslation } from "react-i18next";

const ProcessingInfoDialog = ({ open, onClose, processing }) => {

  const { t } = useTranslation();

  console.log(processing)

  if (!processing) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <Box sx={{ p: 3 }}>
      <DialogTitle><Typography variant="h4" component="div">{t(processing.title)}</Typography></DialogTitle>
      <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
              position: 'absolute',
              right: 16,
              top: 16,
              color: theme.palette.grey[500],
          })}
          >
          <CancelIcon />
        </IconButton>
      <DialogContent dividers>
        <Stack spacing={3}>
        {processing.description && (
          <Typography color="text.secondary" variant="body2">
            {t(processing.description)}
          </Typography>
        )}
        {processing.url && (
          <Box mb={2} textAlign="center">
            <CardMedia
                image={processing.url}
                sx={{
                borderRadius: "20px",
                width: "100%",
                height: 0,
                paddingBottom: "min(75%, 450px)",
                backgroundColor: "rgba(0,0,0,0.08)",
                boxShadow: '0 5px 22px rgba(0, 0, 0, 0.3)',
                }}
            /> 
          </Box>
        )}
        {processing.output && (
          <Typography color="text.secondary" variant="body2">
             <b>{t("Output")} :</b> {t(processing.output)}
          </Typography>
        )}
        </Stack>
      </DialogContent>
      </Box>
    </Dialog>
  );
};

export default ProcessingInfoDialog;